import axios from 'axios';

export const downloadBase64 = (data, filename, type) => {
  const bufferArray = base64ToArrayBuffer(data);
  return downloadBlob(bufferArray, filename, type);
};

export const downloadBlob = (
  bufferArray,
  filename,
  type = 'application/pdf',
) => {
  const blobStore = new Blob([bufferArray], { type });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blobStore, filename);
    return;
  }
  const nextData = window.URL.createObjectURL(blobStore, {
    type: 'text/plain',
  });
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.href = nextData;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(nextData);
  link.remove();
};

export const base64ToArrayBuffer = (data) => {
  const bString = window.atob(data);
  const bLength = bString.length;
  const bytes = new Uint8Array(bLength);
  for (let i = 0; i < bLength; i++) {
    const ascii = bString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

export const getFileNameWithoutExtension = (filename) => {
  return filename.substring(0, filename.lastIndexOf('.')) || filename;
};

export const downloadDocument = (documentUrl, documentName) =>
  axios({
    url: documentUrl,
    method: 'GET',
    withCredentials: false,
    responseType: 'blob',
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', documentName);
      link.click();
    })
    .catch(() =>
      window.alert(
        'There was a problem downloading the file. Please refresh the page and try again',
      ),
    );
